import { render, staticRenderFns } from "./SimuladoresPlan.vue?vue&type=template&id=4682bddc&scoped=true&"
var script = {}
import style0 from "./SimuladoresPlan.vue?vue&type=style&index=0&id=4682bddc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682bddc",
  null
  
)

export default component.exports